/**
 * 母亲节抽奖：规则富文本弹窗
 */
(function () {
  var prevOverflow = '';
  var lastOpenBtn = null;

  function open(wrap) {
    if (!wrap) {
      return;
    }
    wrap.removeAttribute('hidden');
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    var panel = wrap.querySelector('.ug-mday-lottery__modal-panel[role="dialog"]');
    if (panel) {
      panel.focus();
    }
  }

  function close(wrap) {
    if (!wrap) {
      return;
    }
    wrap.setAttribute('hidden', '');
    document.body.style.overflow = prevOverflow;
    if (lastOpenBtn && lastOpenBtn.focus) {
      lastOpenBtn.focus();
    }
    lastOpenBtn = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest) {
      var o = t.closest('[data-ug-ml-open-rules]');
      if (o) {
        e.preventDefault();
        var id = o.getAttribute('aria-controls');
        if (!id) {
          return;
        }
        var panel = document.getElementById(id);
        var wrap = panel && panel.closest && panel.closest('[data-ug-ml-modal]');
        if (wrap) {
          lastOpenBtn = o;
          open(wrap);
        }
        return;
      }
    }
    if (t && t.getAttribute) {
      if (t.getAttribute('data-ug-ml-close') !== null) {
        var w = t.closest && t.closest('[data-ug-ml-modal]');
        close(w);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openM = document.querySelector('[data-ug-ml-modal]:not([hidden])');
      if (openM) {
        e.preventDefault();
        close(openM);
      }
    }
  });
})();
